import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Col, Row, Button, Form, FormGroup, Label, Input } from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import { v4 as uuidv4 } from "uuid";
import CurrencyInput from "react-currency-input-field";

function SociedadesCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_SOCIEDADES = process.env.REACT_APP_URL_SOCIEDADES;
  const URL_SOCIOS = process.env.REACT_APP_URL_SOCIOS;
  const URL_PARTICIPACIONES = process.env.REACT_APP_URL_PARTICIPACIONES;
  const URL_TIPO_INMUEBLE = process.env.REACT_APP_URL_TIPO_INMUEBLE;

  const [nombre, setNombre] = useState("NA");
  const [observaciones, setObservaciones] = useState("NA");
  const [totalParicipacion, setTotalParicipacion] = useState(0);
  const [validaBoton, setValidaBoton] = useState(true);

  const [socios, setSocios] = useState([]);

  const [inputFields, setInputFields] = useState([{
    id: uuidv4(),
    idSocio: "",
    participacion: 0
  }]);

  useMemo(() => {
    axios
      .get(URL_SOCIOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allSocios = response.data

        setSocios(allSocios);
        //
      })
      .catch((err) => {
        console.log(err);
      });
    
  }, []);



  const saveSociedades = async (event) => {
    event.preventDefault();
    setValidaBoton(false);

    if(totalParicipacion > 100){
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La participacion no puede ser mayor a 100%",
      })
      return
    }

    let totIF = inputFields.length

    try {
      await axios
        .post(
          URL_SOCIEDADES,
          {
            observaciones,
            nombre,
            ventas: 0,
            gastos: 0,
            repartido: 0,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((data) => {

          inputFields.map((a) => {
            axios
              .post(
                URL_PARTICIPACIONES,
                {
                  sociedades: data.data._id,
                  socios: a.idSocio,
                  participacion: a.participacion
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then(() => {
                totIF = totIF - 1
                if(totIF == 0){
                Swal.fire("Good job!", "Actualizado con exito", "success");
                setTimeout(() => {
                  window.location.reload();
                }, 2000);
                }
              })
              .catch((error) => {
                console.log(error);
              });
          });

        
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
      console.log(error);
    }
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);

    const total = newInputFields.reduce((acc, curr) => acc + parseFloat(curr.participacion), 0);

    setTotalParicipacion(total);
  };

  const handleAddFields = () => {

    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        idSocio: "",
        participacion: 0,
      },
    ]);
  };


  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menuSocios ? (
        <div className="card container">
          <h3 align="center">Nueva Sociedad</h3>
          <Form onSubmit={saveSociedades}>
            <Row>
             
              <Col md={3}>
                <Label>Nombre </Label>
                <Input
                  type="text"
                  placeholder="Nombre"
                  value={nombre}
                  required
                  onChange={(e) => {
                    setNombre(e.target.value);
                  }}
                />
              </Col>
            
            </Row>
            <Row>
              <Col md={9}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col md={3}>
              <Label>Socio</Label>
              </Col>
              
              <Col md={3}>
              <Label>Paricipacion</Label>
              </Col>
            </Row>

                    {
                      inputFields.map((inputField) => (
                        <div key={inputField.id}>
                          <Row>
                            <Col md={3}>
                              <Input
                                type="select"
                                name="idSocio"
                                value={inputField.idSocio}
                                required
                                onChange={(event) => handleChangeInput(inputField.id, event)}
                              >
                                <option value="">Selecciona</option>
                                {socios.map((a) => (
                                  <option value={a._id}>
                                    {a.name}
                                  </option>
                                ))}
                              </Input>
                            </Col>
                            <Col md={3}>
                              <Input
                                type="number"
                                name="participacion"
                                value={inputField.participacion}
                                required
                                onChange={(event) => handleChangeInput(inputField.id, event)}
                              />
                            </Col>
                            <Col>
                          <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            disabled={inputFields.length === 1}
                            onClick={() => handleRemoveFields(inputField.id)}
                            tabindex="-1"
                          >
                            <i class="fas fa-minus"></i>
                          </Button>
                          <Button
                            size="sm"
                            className="btn"
                            color="info"
                            onClick={handleAddFields}
                            tabindex="-1"
                          >
                            <i class="fas fa-plus"></i>
                          </Button>
                        </Col>
                            </Row>
                            </div>
                      ))
                    }
                    <br />
                    <Row className="negrita">
                      <Col md={3}>
                      <Label>TOTAL</Label>
                      </Col>
                      <Col md={3}>
                      <Label>{totalParicipacion}%</Label>
                      </Col>
                    </Row>

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/Sociedades"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
        </div>
      ) : undefined}
    </>
  );
}

export default SociedadesCreate;
